import React from 'react';
import { Form } from 'reactstrap';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { TableSimpleRow } from '../TableSimpleRow';

export class PersonPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Form>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <tbody>
                        <TableSimpleRow title='First name' text={this.props.person.FirstName} />
                        <TableSimpleRow title='Last name' text={this.props.person.LastName} />

                        <TableSimpleRow title='Second Owner' text={this.props.person.SecondOwner} />
                        <TableSimpleRow title='Email Address' text={this.props.person.Email} />
                        <TableSimpleRow title='2nd Email Address' text={this.props.person.Email2} />
                        <TableSimpleRow title='Mobile' text={this.props.person.Mobile} phone={true} />
                        <TableSimpleRow title='Mobile2' text={this.props.person.Mobile2} phone={true} />
                        <TableSimpleRow title='Home' text={this.props.person.Home} phone={true} />
                        <TableSimpleRow title='Address Line 1' text={this.props.person.AddressLine1} />
                        <TableSimpleRow title='Address Line 2' text={this.props.person.AddressLine2} />
                        <TableSimpleRow title='Postcode' text={this.props.person.Postcode} />

                        {this.props.person.Type === 'Walker'
                            ? <TableSimpleRow title='Covered Postcodes' text={this.props.person.CoveredPostcodes} />
                            : null}

                        {ArcaSecurity.IsAdmin
                            ? <TableSimpleRow title='Type' text={this.props.person.Type} />
                            : null}
                        {ArcaSecurity.IsAdmin
                            ? <TableSimpleRow title='Status' text={this.props.person.State} />
                            : null}
                    </tbody>
                </table>
            </Form>
        );
    }
}